import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormGroupDirective } from "@angular/forms";
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.scss']
})
export class TermsConditionsComponent implements OnInit {
  @Input() formGroupName: string;
  public Editor = ClassicEditor;
  termsForm: FormGroup;
  editorConfig = {
    toolbar: {
      items: [
        'undo', 'redo',
        '|',
        'heading',
        '|',
        'fontfamily', 'fontsize', 'fontColor', 'fontBackgroundColor',
        '|',
        'bold', 'italic', 'strikethrough', 'subscript', 'superscript', 'code',
        '|',
        'link', 'uploadImage', 'blockQuote', 'codeBlock',
        '|',
        'alignment',
        '|',
        'bulletedList', 'numberedList', 'todoList', 'outdent', 'indent'
      ],
      shouldNotGroupWhenFull: true
    },
    height: '200px',
    width: '100%',
    enterMode: 'p', // Force paragraph on enter
    // shiftEnterMode: ClassicEditor.ENTER_BR, // Force line break on shift+enter
    keystrokes: [
      [ 13 /*Enter*/, 'enter' ]
    ]
  };

  constructor(private rootFormGroup: FormGroupDirective) { }

  ngOnInit(): void {
    this.termsForm = this.rootFormGroup.control.get(this.formGroupName) as FormGroup;
  }

}
